import "./MasteryTracks.module.css";
import ApexNavigation from "@/reusable_sections/Header";
import SpecializedStemCurriculum from "./sections/SpecializedStemCurriculum";
import TheStemAdvantage from "./sections/TheStemAdvantage";
import ApexFooter from "@/reusable_sections/Footer";
export default function MasteryTracksPage() {
  return <div>
      <ApexNavigation />
      <SpecializedStemCurriculum />
      <TheStemAdvantage />
      <ApexFooter />
    </div>;
}